module.exports = __webpack_public_path__ + "img/featured-line.9df99862.svg";